import React from "react";

export default function SectionHeading({ eyebrow, title, subtitle, align = "left", dark = false, className = "" }) {
  const center = align === "center";
  return (
    <div className={`${center ? "text-center mx-auto max-w-2xl" : ""} ${className}`}>
      {eyebrow && (
        <div className={`flex items-center gap-3 ${center ? "justify-center" : ""}`}>
          <span className={`w-10 h-px origin-left animate-line-grow ${dark ? "bg-white/35" : "bg-brand-accent/45"}`} />
          <span className={`eyebrow ${dark ? "text-brand-glow/90" : "text-brand-accent"}`}>{eyebrow}</span>
          {center && <span className={`w-10 h-px ${dark ? "bg-white/35" : "bg-brand-accent/45"}`} />}
        </div>
      )}
      <h2
        className={`mt-5 font-display text-2xl sm:text-3xl md:text-4xl font-medium leading-[1.15] tracking-[-0.03em] ${
          dark ? "text-white" : "text-brand-ink"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-5 text-sm md:text-base leading-relaxed font-light ${dark ? "text-slate-400" : "text-brand-muted"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
